import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
export interface PillOption {
    name: string;
    value: string;
}
export interface PillField {
    name: string;
    value: string;
    type: string;
    options: PillOption[];
}
@Component({
    selector: 'app-kyc-pills',
    templateUrl: './pills.component.html',
    styleUrls: ['./pills.component.scss'],
})
export class PillsComponent implements OnInit {
    @Input() field: PillField;
    @Output() changeOption = new EventEmitter<{}>();

    activeOption: string;

    get options() {
        return this.field.options;
    }

    selectOption(optionValue: PillOption) {
        this.activeOption = optionValue.value;
        this.changeOption.emit({
            name: this.field.value,
            value: optionValue.value,
        });
    }

    constructor() {}

    ngOnInit() {
    }
}
